import { Box, Heading, Text, useBreakpointValue } from '@chakra-ui/react';
import Row from '@inspire/ui/chakra/layout/Row';
import A1ConnectWC from 'components/utils/A1ConnectWC';
import A1ConnectLandingPageFooter from 'components/landing-pages/a1connect-landing-page-footer';
import Image from 'next/image';
import LogoA1 from '../../../public/img/article1-yellow.png';
import LogoDemain from '../../../public/img/landing-pages/logo-dema1n.svg';
import LogoInspire from '@inspire/ui/assets/logo.svg';
import LogoJobReady from '../../../public/img/landing-pages/logo-jobready.svg';
import { inspireYellow, lightBeigeBg } from '@inspire/ui/static';

const A1ConnectLandingPageIntermediaireCampagne = ({ pageConfig }) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box>
      {/* Row Image et Description */}
      <Row
        id="welcome-img"
        minHeight="80vh"
        bg="transparent url('/img/landing-pages/campagne/welcome-lp-campagne.jpg') no-repeat 58% 0%"
        bgSize="cover"
        position="relative"
        display="flex"
        flexDirection={['column', 'column', 'row']}
        justifyContent="space-around"
      >
        {/* Superposition semi-transparente sur l'image de bienvenue en desktop */}
        <Box
          width="100%"
          height="100%"
          backgroundColor="rgba(0, 0, 0, 0.5)"
          zIndex={0}
          top="0"
          left="0"
          bottom="0"
          right="0"
          position="absolute"
        />

        {/* Texte description */}
        <Box
          justifyContent="center"
          display="flex"
          flexDirection="column"
          p={10}
          pt={['1vh', '1vh', '0']}
          zIndex={1}
        >
          {/* Texte */}
          <Heading as="h2" size="2xl" color={'white'}>
            {pageConfig.description.header}
          </Heading>
          <Text color={'white'} fontSize={['lg', 'lg', '4xl']}>
            <b>INSPIRE</b> {pageConfig.description.text}
          </Text>
        </Box>

        {/* WebComponent A1C */}
        <Box
          justifyContent="center"
          display="flex"
          flexDirection="column"
          p={10}
          pt={['1vh', '1vh', '0']}
          zIndex={1}
          minW={[null, null, '500px']}
          mt={[null, null, '50px']}
        >
          <A1ConnectWC inscriptionPath={pageConfig.inscriptionPath} />
        </Box>
      </Row>

      {/* Row A1 */}
      <Row
        bg={lightBeigeBg}
        display="flex"
        flexDir={['column', 'column', 'row']}
        alignItems={['center', 'center', null]}
      >
        <Box width={['100%', '100%', '40%']} bg={inspireYellow}>
          <Image alt="Logo Article1" src={LogoA1} />
        </Box>
        <Box
          display="flex"
          flexDir="row"
          justifyContent="space-around"
          width="100%"
          p={['20px', '20px', null]}
        >
          <Image
            alt="Logo Deam1n"
            src={LogoDemain}
            width="200px"
            height="100%"
          />
          <Image
            alt="Logo Inspire"
            src={LogoInspire}
            width="200px"
            height="100%"
          />
          <Image
            alt="Logo JobReady"
            src={LogoJobReady}
            width="200px"
            height="100%"
          />
        </Box>
      </Row>

      {/* Row nous rejoindre */}
      <A1ConnectLandingPageFooter
        isMobile={isMobile}
        inscriptionPath={pageConfig.inscriptionPath}
      />
    </Box>
  );
};

export default A1ConnectLandingPageIntermediaireCampagne;
